





































import Vue from 'vue';
import { Route } from 'vue-router';
import Pagination from '@/components/Pagination.vue';
import PracticeListing from '@/components/PracticeListing.vue';

export default Vue.extend({
  name: 'SearchPractices',
  components: {
    Pagination,
    PracticeListing,
  },
  props: {
    page: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      count: 0,
      limit: 8,
      practices: null,
      // @ts-ignore - ignoring this for this version, to be fixed in Nuxt implementation
      search: this.$options.filters.normalizeString(this.$route.query.s),
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    $route: 'routeChanged',
  },
  methods: {
    fetchData() {
      if (!this.search) {
        this.$router.push({
          name: 'community',
        });
        return;
      }

      window.scrollTo(0, 0);

      // Reassign this scope for callback usage
      const component = this;

      // Calculated offset based on page
      const offset = (parseInt(this.page, 10) - 1) * this.limit;

      if (offset < 0) {
        this.$router.push({
          name: 'bestPractices',
          params: {
            page: '1',
          },
        });
        return;
      }

      fetch(`https://api.pocketyoga.com/practices?search_term=${this.search}&count=true&search_teachers=true&limit=${this.limit}&offset=${offset}`, {
        headers: { version: '2' },
      })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        })
        .then((json) => {
          if (json.count === 0) {
            this.$router.push({
              name: 'search',
              query: {
                s: component.search,
              },
            });
            return;
          }

          component.practices = json.data;
          component.count = json.count;

          // If we've past the last page then wrap to first
          if (offset >= component.count) {
            this.$router.push({
              name: 'searchPractices',
              params: {
                page: '1',
              },
              query: {
                s: component.search,
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onPageChange(page: Number) {
      this.$router.push({
        name: 'searchPractices',
        params: {
          page: page.toString(),
        },
        query: {
          s: this.search,
        },
      });
      this.practices = null;
    },
    onSearchChange(search: string) {
      this.$router.push({
        name: 'search',
        query: {
          s: search
        },
      });
    },
    routeChanged() {
      this.fetchData();
    },
  },
  filters: {
    normalizeString(value: string | undefined) {
      if (!value) {
        return undefined;
      }

      const val = value.trim();

      if (!val.length) {
        return undefined;
      }

      return val;
    },
  },
});
